export function crossSellerCheckBoxes(formData) {
    let crossSellerCheckBoxes = document.querySelectorAll('input[type="checkbox"][name="cross-seller-option"]:checked');

    if (crossSellerCheckBoxes.length > 0) {
        let crossSellerValues = Array.from(crossSellerCheckBoxes).map(checkbox => checkbox.value);
        formData.append("cross_sellers", JSON.stringify(crossSellerValues));
    }
}
